module.exports = __webpack_public_path__ + "media/images/categories/6-b19e7cf4fd5c37b71c4e172e89c53d78.png";